import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CheckCircle2 } from "lucide-react";
import { useApi } from "@/lib/api";

const fmtD = (iso) => iso.split("-").reverse().join("/");

export function ExpiryAlerts() {
  const api = useApi();
  const [list, setList] = useState(null);
  useEffect(() => {
    api.get("/admin/expiry-alerts").then((r) => setList(r.data)).catch(() => setList([]));
  }, [api]);
  if (list === null) return null;
  return (
    <div className="rounded-lg border border-white/10 bg-[#141414] p-5" data-testid="expiry-alerts">
      <div className="flex items-center justify-between">
        <h2 className="flex items-center gap-2 text-lg font-semibold"><AlertTriangle className="h-5 w-5 text-amber-400" />Car documents &amp; service</h2>
        <Link to="/admin/cars" className="text-sm text-[#FF5A00]">Update dates</Link>
      </div>
      {list.length === 0 && <p className="mt-4 flex items-center gap-2 text-sm text-neutral-400" data-testid="expiry-alerts-empty"><CheckCircle2 className="h-4 w-4 text-emerald-400" />Nothing expiring in the next 30 days.</p>}
      <div className="mt-4 divide-y divide-white/5">
        {list.map((a) => (
          <div key={`${a.car_id}-${a.doc}`} className="flex flex-wrap items-center justify-between gap-2 py-2.5 text-sm" data-testid={`expiry-${a.car_id}-${a.doc}`}>
            <div><p className="font-medium">{a.car_name}</p><p className="text-xs text-neutral-500">{a.label} · {fmtD(a.date)}</p></div>
            <span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${a.status === "EXPIRED" ? "bg-rose-500/15 text-rose-400" : "bg-amber-500/15 text-amber-300"}`}>
              {a.status === "EXPIRED" ? `Expired ${-a.days_left} day${a.days_left === -1 ? "" : "s"} ago` : a.days_left === 0 ? "Expires today" : `${a.days_left} day${a.days_left === 1 ? "" : "s"} left`}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}
